import axios from "axios";
import Qs from 'qs';
import Vue from "vue";
import router from '../../router/index';
import {
  Loading
} from 'element-ui';
axios.defaults.headers["Content-Type"] = "application/x-www-form-urlencoded";
var loading;
axios.interceptors.request.use(function (config) {
  if (!config.needLoading) {
    loading = Loading.service();
  }
  return config;
}, function (error) {
  Vue.prototype.$message.error(error)
  return Promise.reject(error);
});
axios.interceptors.response.use((res) => {
  loading.close();
  return res;
}, err => {
  loading.close();
  Vue.prototype.$message.error("网络出错了");
  throw new Error(err);
});
class Ax {
  constructor() {

  }
  Axios(type, url, data, cb) {
    axios({
        method: type,
        url: url,
        responseType: "json",
        params: type == 'get' ? data : {},
        data: type == 'post' ? data : {},
        transformRequest: [function (data) {
          return Qs.stringify(data);
        }],
        needLoading: data.needLoading || false
      })
      .then(response => {
        if (response.status==200 && response.data.code == 401) {
          localStorage.setItem('userName', '');
          localStorage.setItem('userType', '');
          router.push({path: '/login', query: {}});
          return;
        }
        cb && cb(response.data);
      })
      .catch(function () {})
  }
}
let ax = new Ax();
export default ax;